var _defs, _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 388.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c879b;}.cls-2{fill:#eaeaea;}.cls-3{fill:#f44336;}.cls-4{fill:#ffeb3b;}.cls-5{fill:#4caf50;}.cls-6{fill:#29c1de;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512,95.39V416.61a33.5,33.5,0,0,1-33.5,33.49h-445A33.49,33.49,0,0,1,0,416.61V95.39A33.48,33.48,0,0,1,33.49,61.9h445A33.49,33.49,0,0,1,512,95.39Z",
    transform: "translate(0 -61.9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M512,95.39V148H0V95.39A33.48,33.48,0,0,1,33.49,61.9h445A33.49,33.49,0,0,1,512,95.39Z",
    transform: "translate(0 -61.9)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 53.35,
    cy: 42.19,
    r: 17.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 111.43,
    cy: 42.19,
    r: 17.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 169.49,
    cy: 42.19,
    r: 17.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.44,340.8h-56c-5.83,0-10.26-4-10.26-10.73C55.21,328.2,86,215.32,86,215.32a13.6,13.6,0,0,1,12.83-7.93c5.36,0,18.81,3.62,18.81,10.62,0,1.16.06,3.61-.64,5L94.15,312.57h27.29V288.09c0-6.77,7.7-9.57,15.16-9.57,7.7,0,15.16,2.8,15.16,9.57v24.48h11c6.3,0,9.57,7,9.57,14.23,0,7-4.67,14-9.57,14h-11v27.53c0,6.29-7.46,9.56-15.16,9.56-7.46,0-15.16-3.27-15.16-9.56V340.8Z",
    transform: "translate(0 -61.9)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M406,340.8H350c-5.84,0-10.27-4-10.27-10.73,0-1.87,30.79-114.75,30.79-114.75a13.6,13.6,0,0,1,12.82-7.93c5.37,0,18.82,3.62,18.82,10.62,0,1.16.06,3.61-.64,5l-22.84,89.55H406V288.09c0-6.77,7.7-9.57,15.16-9.57,7.7,0,15.16,2.8,15.16,9.57v24.48h11c6.3,0,9.56,7,9.56,14.23,0,7-4.66,14-9.56,14h-11v27.53c0,6.29-7.46,9.56-15.16,9.56-7.46,0-15.16-3.27-15.16-9.56V340.8Z",
    transform: "translate(0 -61.9)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.92,325.87V260.8c0-39,23.79-53.41,54.57-53.41s54.81,14.46,54.81,53.41v65.07c0,38.95-24,53.41-54.81,53.41S198.92,364.82,198.92,325.87ZM278,260.8c0-18.43-9.33-26.82-24.49-26.82-15.39,0-24.25,8.39-24.25,26.82v65.07c0,18.42,8.86,26.82,24.25,26.82,15.16,0,24.49-8.4,24.49-26.82Z",
    transform: "translate(0 -61.9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.92e3b283368007f511dae7c80182762c.svg";
export { ForwardRef as ReactComponent };